var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndexBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1171,
    viewBox: "0 0 1600 1171",
    width: 1600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-127 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m833 296c-135.312059 0-245-109.687941-245-245h245z",
    fill: "#5e72e4",
    transform: "matrix(.65605903 -.75470958 .75470958 .65605903 113.427948 595.894915)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 126c132.397954 0 239.729763 107.33181 239.729763 239.729763h-239.729763z",
    fill: "#11cdef",
    transform: "matrix(0 1 -1 0 365.729764 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930 126c44.1824 0 80 35.8176 80 80s-35.8176 80-80 80-80-35.8176-80-80 35.8176-80 80-80z",
    fill: "#172b4d",
    transform: "matrix(0 1 -1 0 1136 -724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414 126c132.397954 0 239.729763 107.33181 239.729763 239.729763h-239.729763z",
    fill: "#11cdef",
    transform: "matrix(0 1 -1 0 779.729764 -288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.058248 849.322561v-119.864881c0-66.198977-53.665905-119.864882-119.864882-119.864882v119.864882c0 66.198976 53.665905 119.864881 119.864882 119.864881z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1680.98172 247.189358h-119.86488c-66.19898 0-119.86488 53.665905-119.86488 119.864882h119.86488c66.19897 0 119.86488-53.665905 119.86488-119.864882z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1349.32077 171.776979h-119.86488c-66.19897 0-119.86488 53.665905-119.86488 119.864882h119.86488c66.19898 0 119.86488-53.665905 119.86488-119.864882z",
    fill: "#172b4d",
    transform: "matrix(.9781476 -.20791169 .20791169 .9781476 -21.308536 260.68166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1681.72976 366h-119.86488c-66.19898 0-119.86488 53.665425-119.86488 119.864882h119.86488c66.19898 0 119.86488-53.665426 119.86488-119.864882z",
    fill: "#f0f1f1",
    transform: "matrix(1 0 0 -1 0 851.864882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1532 127h-211.5c-116.80722 0-211.5 53.665425-211.5 119.864882h211.5c116.80722 0 211.5-53.665426 211.5-119.864882z",
    fill: "#172b4d",
    transform: "matrix(1 0 0 -1 0 373.864882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1407.5 107c34.5175 0 62.5 27.9825 62.5 62.5s-27.9825 62.5-62.5 62.5-62.5-27.9825-62.5-62.5 27.9825-62.5 62.5-62.5z",
    fill: "#fff",
    transform: "matrix(0 1 -1 0 1577 -1238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1486.5 127c34.5175 0 62.5 27.9825 62.5 62.5s-27.9825 62.5-62.5 62.5-62.5-27.9825-62.5-62.5 27.9825-62.5 62.5-62.5z",
    fill: "#172b4d",
    transform: "matrix(0 1 -1 0 1676 -1297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m962.859654 126h-119.864882c-66.198977 0-119.864882 53.665425-119.864882 119.864882h119.864882c66.198977 0 119.864882-53.665426 119.864882-119.864882z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1777.72976 245.864882h-119.86488c-66.19898 0-119.86488-53.66541-119.86488-119.864882h119.86488c66.19898 0 119.86488 53.665445 119.86488 119.864882z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.330203 1131.55101 119.89056.0202c66.213157.01114 119.881386-52.89345 119.870075-118.16448l-119.890559-.02019c-66.213157-.01115-119.881387 52.89345-119.870076 118.16447z",
    fill: "#172b4d",
    transform: "matrix(-.8480481 -.52991926 -.52991926 .8480481 1180.420188 338.480042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.696401 126v119.258913c0 66.533641 53.665904 120.47085 119.864881 120.47085v-119.258913c0-66.53605-53.665905-120.47085-119.864881-120.47085z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.455293 126v239.729763c0 132.397954-107.331809 239.729763-239.729763 239.729763v-239.729763c0-132.397953 107.33181-239.729763 239.729763-239.729763z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.058248 370.896353v119.258913c0 66.533641-53.665905 120.47085-119.864882 120.47085v-119.258913c0-66.536051 53.665905-120.47085 119.864882-120.47085z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.654739 900.988458h-119.258913c-66.533641 0-120.47085 53.665905-120.47085 119.864882h119.258913c66.536051 0 120.47085-53.665905 120.47085-119.864882z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.790297 1120.55399h57.797093c32.244559 0 58.384441 26.0084 58.384441 58.09077h-57.797093c-32.245727 0-58.384441-26.0084-58.384441-58.09077z",
    fill: "#fb6340",
    transform: "matrix(.83867057 .54463904 -.54463904 .83867057 717.087306 -121.647424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1543.91155 1286.21101v-119.26012c0-66.53297 53.6659-120.46964 119.86488-120.46964v119.26013c0 66.53297-53.6659 120.46963-119.86488 120.46963z",
    fill: "#172b4d",
    transform: "matrix(.81915204 .57357644 -.57357644 .81915204 959.040565 -708.995806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1515.97268 1010.0035c0-39.663753 32.15185-71.815596 71.8156-71.815596 39.66376 0 71.8156 32.151843 71.8156 71.815596 0 39.66376-32.15184 71.8156-71.8156 71.8156-39.66375 0-71.8156-32.15184-71.8156-71.8156z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1552.13881 1010.0035c0-19.688012 15.96146-35.649468 35.64947-35.649468s35.64947 15.961456 35.64947 35.649468c0 19.68802-15.96146 35.64947-35.64947 35.64947s-35.64947-15.96145-35.64947-35.64947z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1347.54186 1046.16963c0-19.68801 15.96145-35.64947 35.64947-35.64947 19.68801 0 35.64947 15.96146 35.64947 35.64947s-15.96146 35.64947-35.64947 35.64947c-19.68802 0-35.64947-15.96146-35.64947-35.64947z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1621.37111 888.071984c0-19.688013 15.96146-35.649469 35.64947-35.649469 19.68802 0 35.64947 15.961456 35.64947 35.649469 0 19.688014-15.96145 35.649469-35.64947 35.649469-19.68801 0-35.64947-15.961455-35.64947-35.649469z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639 306.649469c0-19.688013 15.961456-35.649469 35.649469-35.649469 19.688014 0 35.649469 15.961456 35.649469 35.649469 0 19.688014-15.961455 35.649469-35.649469 35.649469-19.688013 0-35.649469-15.961455-35.649469-35.649469z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1568 366.649469c0-19.688013 15.96146-35.649469 35.64947-35.649469s35.64947 15.961456 35.64947 35.649469c0 19.688014-15.96146 35.649469-35.64947 35.649469s-35.64947-15.961455-35.64947-35.649469z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.492304 1001.73696c0 19.68801-15.960742 35.64947-35.649469 35.64947-19.688726 0-35.649469-15.96146-35.649469-35.64947 0-19.688015 15.960743-35.649471 35.649469-35.649471 19.688727 0 35.649469 15.961456 35.649469 35.649471z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1747.72976 722.729763c-132.39795 0-239.72976-107.331809-239.72976-239.729763h239.72976z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.925438 907.705025c0 19.688014-15.960743 35.649469-35.649469 35.649469-19.688727 0-35.64947-15.961455-35.64947-35.649469 0-19.688013 15.960743-35.649469 35.64947-35.649469 19.688726 0 35.649469 15.961456 35.649469 35.649469z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#11cdef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1657 924.032856c0-17.691628 14.34123-32.032856 32.03286-32.032856 17.69162 0 32.03285 14.341228 32.03285 32.032856s-14.34123 32.032857-32.03285 32.032857c-17.69163 0-32.03286-14.341229-32.03286-32.032857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.15774 855.522469c0-17.691628 14.341703-32.032856 32.032856-32.032856 17.691154 0 32.032856 14.341228 32.032856 32.032856s-14.341702 32.032856-32.032856 32.032856c-17.691153 0-32.032856-14.341228-32.032856-32.032856z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 175.032856c0-17.691628 14.341703-32.032856 32.032856-32.032856 17.691154 0 32.032857 14.341228 32.032857 32.032856s-14.341703 32.032857-32.032857 32.032857c-17.691153 0-32.032856-14.341229-32.032856-32.032857z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1744.99815 759.997873c0-34.240002-27.75787-61.997873-62.00028-61.997873-34.24 0-61.99787 27.757871-61.99787 61.997873 0 34.24241 27.75787 62.00028 61.99787 62.00028h62.00028z",
    fill: "#f0f1f1",
    transform: "matrix(-1 0 0 1 3365.998154 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1442 206c0-51.91432-42.08568-94-94-94s-94 42.08568-94 94 42.08568 94 94 94h94z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1531.99815 245.997873c0-34.240002-27.75787-61.997873-62.00028-61.997873-34.24 0-61.99787 27.757871-61.99787 61.997873 0 34.24241 27.75787 62.00028 61.99787 62.00028h62.00028z",
    fill: "#11cdef",
    transform: "matrix(1 0 0 -1 0 491.998154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m962.503912 213c0 48.04836 38.951638 87 86.999998 87s87-38.95164 87-87-38.95164-87-87-87h-86.999998z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m962.503912 183.501116c0 31.755314 25.74357 57.498884 57.501118 57.498884 31.75531 0 57.49888-25.74357 57.49888-57.498884 0-31.757546-25.74357-57.501116-57.49888-57.501116h-57.501118z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242 679.5c0-57.16098 46.33902-103.5 103.5-103.5s103.5 46.33902 103.5 103.5-46.33902 103.5-103.5 103.5-103.5-46.33902-103.5-103.5z",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 679.5c0-31.755616 25.744384-57.5 57.5-57.5s57.5 25.744384 57.5 57.5-25.744384 57.5-57.5 57.5-57.5-25.744384-57.5-57.5z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1742.93152 607.931517c-67.34206 0-121.93152-54.589457-121.93152-121.931517h121.93152z",
    fill: "#5e72e4",
    transform: "matrix(0 -1 -1 0 2228.931518 2228.931518)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#11cdef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1584.47574 709.505494c0-19.688013 15.96146-35.649469 35.64947-35.649469 19.68802 0 35.64947 15.961456 35.64947 35.649469 0 19.688014-15.96145 35.649469-35.64947 35.649469-19.68801 0-35.64947-15.961455-35.64947-35.649469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1633 411.649469c0-19.688013 15.96146-35.649469 35.64947-35.649469s35.64947 15.961456 35.64947 35.649469c0 19.688014-15.96146 35.649469-35.64947 35.649469s-35.64947-15.961455-35.64947-35.649469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 1176.86488c0-66.19898 53.6659048-119.86488 119.864882-119.86488 66.198976 0 119.864881 53.6659 119.864881 119.86488s-53.665905 119.86488-119.864881 119.86488c-66.1989772 0-119.864882-53.6659-119.864882-119.86488z",
    transform: "matrix(0 1 -1 0 1307.729764 1046)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexBg);
export default __webpack_public_path__ + "static/media/index_bg.ae54c4822412bfcc821ff432a829942f.svg";
export { ForwardRef as ReactComponent };